/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { GmxTrader, GmxTraderInterface } from "../GmxTrader";

const _abi = [
  {
    inputs: [],
    name: "AmountInAndOutAreZeroOrSameValue",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "BadReturnValueFromERC20OnTransfer",
    type: "error",
  },
  {
    inputs: [],
    name: "CannotBeNativeChainToken",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "caller",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "ErrorTransferETH",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidContract",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidPermission",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidRequestEncoding",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidRoutPathLenght",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "NoContract",
    type: "error",
  },
  {
    inputs: [],
    name: "NonReentrancy",
    type: "error",
  },
  {
    inputs: [],
    name: "NumberIsZero",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_paramValue",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_msgValue",
        type: "uint256",
      },
    ],
    name: "SanitizeMsgValueFailed",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "identifier",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "TokenTransferGenericFailure",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_address",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes1",
        name: "newPermission",
        type: "bytes1",
      },
    ],
    name: "PermissionChanged",
    type: "event",
  },
  {
    inputs: [],
    name: "BASIS_POINTS_DIVISOR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "CORRECTION_DENOMINATOR",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "EXACT_AMOUNT_IN_CORRECTION",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PRICE_PRECISION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_request",
        type: "bytes",
      },
    ],
    name: "decodeRequestExactInOutParams",
    outputs: [
      {
        components: [
          {
            internalType: "address[]",
            name: "path",
            type: "address[]",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        internalType: "struct GenericRequestExactInOutParams",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_request",
        type: "bytes",
      },
    ],
    name: "decodeSwapRequest",
    outputs: [
      {
        components: [
          {
            internalType: "address[]",
            name: "path",
            type: "address[]",
          },
          {
            internalType: "uint256",
            name: "expectedAmountIn",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "expectedAmountOut",
            type: "uint256",
          },
        ],
        internalType: "struct GenericSwapRequest",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "_request",
        type: "bytes",
      },
    ],
    name: "exchange",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_path",
        type: "address[]",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "generateExpectInOutRequest",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_path",
        type: "address[]",
      },
      {
        internalType: "uint256",
        name: "_expectedAmountIn",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_expectedAmountOut",
        type: "uint256",
      },
    ],
    name: "generateSwapRequest",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_request",
        type: "bytes",
      },
    ],
    name: "getAmountIn",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn_",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_request",
        type: "bytes",
      },
    ],
    name: "getAmountOut",
    outputs: [
      {
        internalType: "uint256",
        name: "_amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_address",
        type: "address",
      },
    ],
    name: "getPermissionLevel",
    outputs: [
      {
        internalType: "bytes1",
        name: "",
        type: "bytes1",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_address",
        type: "address",
      },
      {
        internalType: "bytes1",
        name: "accessLevel",
        type: "bytes1",
      },
    ],
    name: "hasPermissionLevel",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_address",
        type: "address",
      },
      {
        internalType: "bytes1",
        name: "_permission",
        type: "bytes1",
      },
    ],
    name: "setPermission",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address",
        name: "_vaultUtils",
        type: "address",
      },
      {
        internalType: "address",
        name: "_usdg",
        type: "address",
      },
    ],
    name: "setUp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "usdg",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vault",
    outputs: [
      {
        internalType: "contract IVault",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vaultUtils",
    outputs: [
      {
        internalType: "contract IVaultUtils",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type GmxTraderConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: GmxTraderConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class GmxTrader__factory extends ContractFactory {
  constructor(...args: GmxTraderConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<GmxTrader> {
    return super.deploy(overrides || {}) as Promise<GmxTrader>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): GmxTrader {
    return super.attach(address) as GmxTrader;
  }
  override connect(signer: Signer): GmxTrader__factory {
    return super.connect(signer) as GmxTrader__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GmxTraderInterface {
    return new utils.Interface(_abi) as GmxTraderInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GmxTrader {
    return new Contract(address, _abi, signerOrProvider) as GmxTrader;
  }
}
